export default __webpack_public_path__ + "static/navigation_w.aa4738734518297c98afe2f7e847a254.png";